export default {
  child_rewards: {},
  parent_rewards: {},
  rewardsIdeas: [],
  parent_points: 0,
  isDuplicateActivate: false,
  error: false,
  errorMessage: '',
};
